export class RotateInteractiveModeEventArgs extends lt.LeadEventArgs {
  constructor(rotateAngle: number) {
    super();

    this._rotateAngle = rotateAngle;
  }

  private _rotateAngle: number;
  public get rotateAngle(): number {
    return this._rotateAngle;
  }
}
